/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';

export type EstimatedCost = {
  value: number;
  unit: string;
};

export function createEstimatedCost(json?: Partial<EstimatedCost>): EstimatedCost {
  return makeAutoObservable({
    value: json?.value ?? 0,
    unit: json?.unit ?? '',
  });
}
